// src/aws-config.js
import AWS from 'aws-sdk';



// Configure AWS SDK with S3 details
AWS.config.update({
  accessKeyId: "AKIAVXGA6A4K23RUUPSZ",
  secretAccessKey: "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",
  region: "ap-southeast-1",  
});

const s3 = new AWS.S3({
  params: { Bucket: "boaz-email-images" },
  signatureVersion: 'v4',
});
// console.log(process.env);


export default s3;

